"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IModel.js.map